import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';
import { faBullhorn, faCartShopping, faPalette } from "@fortawesome/free-solid-svg-icons";

const labelsFirst = [
    "Redes Sociais",
    "Estratégia de Conteúdo",
    "Meta Business Suite",
    "LinkedIn",
    "Instagram",
    "Facebook",
    "Pinterest",
    "Marketing Digital"
];

const labelsSecond = [
    "E-commerce",
    "Gestão de Website",
    "Gestão de Produto",
    "Conteúdo de Produto",
    "Categorização de Produto",
    "PIM",
    "OpenCart",
    "CMS",
];

const labelsThird = [
    "Adobe Photoshop",
    "Adobe Illustrator",
    "Adobe Premiere Pro",
    "Criação de Conteúdo",
    "Comunicação de Marca",
    "Campanhas",
    "Newsletters",
    "Planeamento de Eventos",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Competências</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faBullhorn} size="3x"/>
                    <h3>Marketing Digital & Redes Sociais</h3>
                    <p>Planeamento de conteúdos, gestão de redes sociais e implementação de campanhas, sempre com foco na consistência da marca.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Focus:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faCartShopping} size="3x"/>
                    <h3>E-commerce & Gestão de Website</h3>
                    <p>Gestão de e-commerce e website: introdução, organização e manutenção de produtos e conteúdos, com foco na coerência do catálogo digital.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Focus:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPalette} size="3x"/>
                    <h3>Conteúdo, Marca & Eventos</h3>
                    <p>Criação de conteúdos e materiais de comunicação, com experiência também no planeamento e execução de eventos.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Focus:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;